module.exports = __webpack_public_path__ + "media/theme/tutorial__dmm--1--redeem-35b49f01.png";